<!--
 * @Author: lan.h
 * @Date: 2021-10-18 09:39:50
 * @LastEditors: lan.h
 * @LastEditTime: 2021-12-01 10:16:00
 * @Description: 
-->
<template>
  <div>
    <div class="menu">
      <div class="menu-left">
        <img src="~/img/logo.png" />
      </div>
      <div class="menu-right">
        <router-link :to="{name:'index'}">首页</router-link>
        <router-link v-for="item in awards_meta" :key="item.id" :to="{name: item.route}">{{item.name}}</router-link>
        <!-- <router-link :to="{name:'vb100List'}">主榜</router-link>
        <router-link :to="{name:'pcAward'}">澎橙奖</router-link>
        <router-link :to="{name:'wlAward'}">蔚澜奖</router-link>
        <router-link :to="{name:'oAward'}">橙果奖</router-link> -->
        <router-link :to="{name:'release'}">历届发布</router-link>
        <router-link :to="{name:'org'}">支持机构</router-link>
        <router-link :to="{name:'report'}">报告下载</router-link>
      </div>
    </div>
    <links></links>
</div>
  
</template>
<script>
import links from '@/components/links.vue'
export default {
  components: {
    links
  },
  computed: {
    awards_meta() {
      return this.$store.state.list_meta.awards_meta.filter(item => item.route)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu
  padding 0 60px
  display flex
  justify-content space-between
  align-items center
  height 64px
  background #101116
  box-shadow 0px 1px 4px 0px rgba(14, 15, 20, 0.1)
  position fixed
  left 0
  top 0
  width 100%
  z-index 2001
  .menu-left 
    img 
      height 30px
  .menu-right
    font-size 16px
    line-height 16px
    font-weight 500
    a 
      color #FFFFFF
      margin-left 40px
    .router-link-exact-active
      color #D9BB9E
      position relative
      &::before
        position absolute
        bottom -8px
        left 0
        width 100%
        height 2px
        background linear-gradient(90deg, #D9BB9E, #C78E66)
        content ''
</style>